const MobileRecognitionQualitiesView = () => {
  return 'QualitiesView'
}

export default MobileRecognitionQualitiesView
